export default __webpack_public_path__ + "static/media/group-2.a068eb49.svg";